export const cantPlaySurahRightNow = 'لا يمكن تشغيل السورة في الوقت الحالي'
export const thereIsNoSurah = 'لا يوجد اي سورة'
export const getMostPlayedSuccess = 'جاري تحميل السور الاكثر استماعا'
export const loadingReciters = 'جاري تحميل القراء'